import { useMemo } from "react";

import { useOrgDesignConfig } from "src/insights/useOrgDesignConfig";
import {
  toScenarioTargetsMap,
  type InsightsTargetsConfig,
  type ScenarioTargetsMap,
} from "src/insights/insightsTargets";

export type UseInsightsTargetsResult = {
  config: InsightsTargetsConfig;
  targetsByScenario: ScenarioTargetsMap;
  managerHealthSeverelyOverloaded: number;
  /**
   * Workspace-level "Enable targets" (Org Design settings). When false,
   * Insights surfaces must not imply targets exist: no target/Δ sublabels,
   * no RAG colouring, no scenario selectors. Defaults to false (absent key).
   */
  showTargets: boolean;
};

export const useInsightsTargets = (): UseInsightsTargetsResult => {
  const { targets, showTargets } = useOrgDesignConfig();

  return useMemo(
    () => ({
      config: targets,
      targetsByScenario: toScenarioTargetsMap(targets),
      managerHealthSeverelyOverloaded: targets.managerHealthSeverelyOverloaded,
      showTargets,
    }),
    [targets, showTargets]
  );
};
